/**
 * Route guard for Workflows v2.
 *
 * Reads `isWorkflowsV2` from the WorkspaceContext (server-derived, propagated via auth.me).
 * When false: redirects to the workspace home.
 * When true: renders children.
 *
 * This is intentionally NOT RequireFlag / FeatureFlagsContext (localStorage). Those are
 * dev-only flags and would either expose the editor to every dev workspace or hide it from
 * enabled production workspaces.
 */
import { Navigate } from 'react-router-dom';

import { useWorkspace } from '@/_shared/contexts/WorkspaceContext';

interface RequireWorkflowsV2Props {
  children: React.ReactNode;
}

export function RequireWorkflowsV2({ children }: RequireWorkflowsV2Props): React.ReactElement {
  const { isWorkflowsV2, wp } = useWorkspace();

  if (!isWorkflowsV2) {
    return <Navigate to={wp()} replace />;
  }

  return <>{children}</>;
}
